import { render, staticRenderFns } from "./InstantActivate.vue?vue&type=template&id=1e7b228e&scoped=true"
import script from "./InstantActivate.vue?vue&type=script&lang=js"
export * from "./InstantActivate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7b228e",
  null
  
)

export default component.exports